import React, {useState, useEffect} from "react";
import {specialities} from "../../Constants/specialities";
import {postAppointmentRequest} from "../../redux/scheduleAppointment/scheduling.actions";
import {purchaseCredits, reduceCreditsCount} from "../../redux/credits/credits.actions";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import moment from "moment";
import jsPDF from "jspdf";
import {paymentUser} from "../../Constants/api";
import {
	Box,
	Button,
	Card,
	Checkbox,
	FormControlLabel,
	Grid,
	makeStyles,
	Typography,
} from "@material-ui/core";
import API from "../../helpers/apiHelpers";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import CircularProgress from "@material-ui/core/CircularProgress";
import {ReactComponent as CheckboxBorder} from "../../Images/checkboxBorder.svg";
import {getUserProfile} from "../../redux/userProfile/userProfile.actions";
import {setIsChangeCreditCard, setPaymentType} from "../../redux/credits/credits.reducers";
import {setPickedTimeSlot, setPaymentMethod} from "../../redux/scheduleAppointment/scheduling.reducers";

interface Props {
    price?: number;
    purchaseType: string;
    disabled: boolean;
    cards?: any;
	setAppointmentData?: any;
    setDisabled?: React.Dispatch<React.SetStateAction<boolean>>;
    pcvCheckBoxValue?: boolean;
    hasSubscription?: boolean;
    referralInvite?: boolean;
    invitation?: any;
    checkTimeslot?: () => any;
	setIsRequestFinish?: (boolean) => any;
    withSaveForNext?: boolean;
    isInPast?: boolean;
	setIsInPast?: (boolean) => any;
    employer?: string;
	myRef?: any;
}

declare global {
    interface Window {
        Square: any;
    }
}
const useStyles = makeStyles({
	cardWrapper: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		height: 105,
		marginBottom: 20,
	},
	cardName: {
		fontFamily: "Merriweather",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 16,
		lineHeight: 26,
		color: "#273878",
	}
});


const PaymentForm = (
	{
		purchaseType,
		cards = null,
		withSaveForNext = false,
		disabled,
		setDisabled,
		pcvCheckBoxValue,
		price = 0,
		hasSubscription = false,
		referralInvite = false,
		invitation = undefined,
		setAppointmentData = null,
		checkTimeslot,
		isInPast,
		setIsInPast,
		setIsRequestFinish,
		employer,
		myRef,
	}: Props) => {
	const classes = useStyles();
	const dispatch = useAppDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();
	// const user = useSelector((state: RootState) => state?.user);
	const scheduling = useSelector((state: RootState) => state?.scheduleAppointment);
	const credits = useSelector((state: RootState) => state?.credits);
	const selectedCard = useSelector((state: RootState) => state?.credits.selectedCard);
	const [card, setCard] = useState<any>();
	const [showSpinner, setShowSpinner] = useState(false);
	const [saveForLater, setSaveForLater] = useState(false);
	const [cardInfo, setCardInfo] = useState<any>();
	const formattedPickedTimeSlot=[`${scheduling.pickedTimeSlot}[${moment.tz.guess()}]`];
	const user = useSelector((state: RootState) => state?.user);
	const location = useSelector((state: RootState) => state?.common.location);
	const checkPaymentInfo = "An issue occurred when charging your card. Please make sure that you are using one of the following card types: Visa, Mastercard, American Express, Discover, Diners Club, JCB";
	//display the card container
	async function initializeCard(payments) {
		const card = await payments.card();
		await card.attach("#card-container");
		return card;
	}

	const iOS = () => {
		return [
			"iPhone Simulator",
			"iPod Simulator",
			"iPhone",
			"iPod",
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document);
	};

	//Tokenize Function
	async function tokenize(paymentMethod) {
		const tokenResult = await paymentMethod.tokenize();
		if (tokenResult.status === "OK") {
			if (tokenResult?.details?.card?.brand === "CHINA_UNIONPAY") {
				return
			}
			setCardInfo(tokenResult?.details?.card);
			return tokenResult;

		} else {
			let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
			if (tokenResult.errors) {
				errorMessage += ` and errors: ${JSON.stringify(
					tokenResult.errors
				)}`;
			}
			throw new Error(errorMessage);
		}
	}


	const handleClick = async (event, paymentMethod) => {
		setIsRequestFinish(true);
		setShowSpinner(true);
		event.preventDefault();
		// Start of payment logic
		const amount = price;
		let nonce;
		let card;
		let cardIdInfo;
		try {
			const res = await tokenize(paymentMethod);
			nonce = res?.token;
			const {brand, expMonth, expYear, last4} = res?.details?.card;
			card = {
				card_brand: brand,
				last_4: last4,
				exp_month: expMonth,
				exp_year: expYear,
			};
		} catch (e) {
			console.error(e.message);
		}
		if (saveForLater && user.email===paymentUser) {
			let profile;
			if (user["userId"]) {
				profile = await dispatch(getUserProfile({userId: user["userId"]}));
			}
			let data = {
				"source_id": nonce,
				card,
			};
			try {
				const newCard = await API.createCreditCard(data);
				cardIdInfo = newCard?.id;
			} catch (e) {
				const message = e.message === "Card already registered" ? "This card is already in use" : checkPaymentInfo;
				enqueueSnackbar(message, {variant: "error", autoHideDuration: 4000});
				setShowSpinner(false);
				return;
			}
		}
		if (selectedCard && user.email===paymentUser) {
			cardIdInfo = selectedCard.id;
		}
		if (hasSubscription) {
			setIsRequestFinish(false);
			if (user.role === "VET") {
				history.push("/appointments");
				return;
			}
			//Do something here:
			const requestBody = {
				ownerSubscriptionPlan: "ADVICE_SUBSCRIPTION",
				userId: user["userId"],
				employer: employer,
				paymentRequest: {
					amount: "USD " + amount.toFixed(2).toString(),
					type: "square",
					nonce: nonce
				}
			};
			API.postSubscriptionPayment(requestBody).then(res => {
				window.sessionStorage.removeItem("specialParams");
				if (Object.prototype.hasOwnProperty.call(res, "ownerSubscriptionPlan")) {
					setIsRequestFinish(false);
					history.push({
						pathname: "/gettingStarted",
						state: {
							hasSubscription: true,
						}
					});
				} else {
					enqueueSnackbar(checkPaymentInfo, {
						variant: "error",
						autoHideDuration: 4000
					});
					setShowSpinner(false);
				}
			})
				.catch((res) => {
					const message = res?.message.includes("already has a subscription")? "You already have an active subscription" : "something has gone wrong";
					enqueueSnackbar(message, {
						variant: "error",
						autoHideDuration: 4000
					});
					setShowSpinner(false);
				});
		} else {
			let specialty = "EXOTICS";
			if (scheduling.selectedPetId) {
				const pet = await API.getAnimalById(scheduling.selectedPetId);
				const petType = pet.type === "Other" ? pet.breed : pet.type;
				const reg = new RegExp(petType, "i");
				specialities.forEach(speciality => {
					if (reg.test(speciality.label)) {
						specialty = speciality.value;
					}
				});
			}
			if (purchaseType === "appointmentPurchase") {
				let requestBody = {
					animalId: scheduling.selectedPetId,
					description: scheduling.additionalInfo,
					chatId: Math.floor(Math.random() * 10001),
					timesRequested: formattedPickedTimeSlot,
					appointmentType: scheduling.serviceType,
					vetSpecialty: specialty,
					state: location === false ? null : location,
					promotionCode: scheduling.promo,
					paymentRequest: {
						type: "square",
						amount: `USD ${amount.toFixed(2).toString()}`,
						nonce: null,
						cardId: null
					},
					funnelEmailGiftId: !!scheduling.funnelEmailGiftId ? scheduling.funnelEmailGiftId : null,
				};
				if (cardIdInfo && user.email===paymentUser) {
					requestBody.paymentRequest.cardId = cardIdInfo;
				} else requestBody.paymentRequest.nonce = nonce;
				if (referralInvite) requestBody["useReferralCodeRequests"] = true;
				if (!scheduling.immediate) requestBody["vetUserId"] = scheduling.vetId;
				if (scheduling.paymentMethod === "WITH_REFERRAL_CODE") requestBody["referralCodeRequestId"] = user["referralCodeRequest"]["id"];
				if (pcvCheckBoxValue) {
					requestBody["isSendRecords"] = pcvCheckBoxValue;
				}
				// const consentForm = JSON.parse(window.localStorage.getItem("pdf"));
				let imgData = JSON.parse(scheduling.pdf);
				const pdf = new jsPDF();
				pdf.addImage(imgData, "jpeg", 20 , 5, iOS() ? 130 : 170, iOS() ? 280 : 260, "consentForm", "NONE", 0);
				// pdf.save("download.pdf");
				const pdfParams = {
					clientId: user["userId"],
					imageUrl: "",
					created: moment.utc().format(),
					vetId: scheduling.vetId,
				};
				dispatch(postAppointmentRequest(requestBody))
					.then(async (res) => {
						pdfParams["appointmentId"] = res.appointmentId;
						if (imgData !== "") {
							const firstStep = await API.addConsentForm(pdfParams).then(res => res.json());
							const url = await API.getConsentURLs(firstStep.id);
							const sendImage = await API.uploadConsentForm(url.uploadUrl, new Blob([pdf.output("blob")], {type: "application/pdf"}));
						}
						API.postAgreement({
							type: "appointment_tos",
							userId: user["userId"],
							appointmentId: res.appointmentId
						});
						setIsRequestFinish(false);
						history.push({
							pathname: "/appointmentConfirmation",
							state: {
								appointmentId: res.appointmentId,
								total: amount,
								type: res.appointmentType,
							}
						});
					})
					.catch((err) => {
						setShowSpinner(false);
						setIsRequestFinish(false);
						if (err.nextDateStatus === "NOT_FOUND") history.push({pathname: "/availableVet", state: {redirect: true}})
						else {
							if (err.nextAvailableTimeslot) {
								dispatch(setPickedTimeSlot([err.nextAvailableTimeslot]));
								setIsInPast(true);
								myRef.current.scrollIntoView();
							} else {
								enqueueSnackbar("Unfortunately some of the used data is corrupted. Please go through schedule process again", {variant: "error"});
							}
						}
					})
					.finally(() => {
						console.log("completed");
					});
			} else if (purchaseType === "creditsPurchase") {
				const requestBody = {
					...credits.newCredit,
					usState: location === false ? null : location,
					paymentRequest: {
						...credits.newCredit.paymentRequest,
						nonce: nonce,
						cardId: null,
					},
				};
				if (referralInvite) {
					requestBody["referralCodeRequestId"] = invitation.id;
				}
				if (cardIdInfo && user.email===paymentUser) {
					requestBody.paymentRequest.cardId = cardIdInfo;
				} else requestBody.paymentRequest.nonce = nonce;
				dispatch(purchaseCredits(requestBody))
					.then((res) => {
						setIsRequestFinish(false);
						history.push({
							pathname: "/schedule"
						});
					})
					.catch((err) => {
						enqueueSnackbar(checkPaymentInfo, {
							variant: "error",
							autoHideDuration: 4000
						});
						console.log("API.purchaseCredits error: ", err);
						setShowSpinner(false);
					})
					.finally(() => {
						console.log("Completed");
					});
			} else if (purchaseType === "bundlePurchase") {
				const requestBodyBundle = {
					clientUserId: credits.newCredit.clientUserId,
					creditPrice: credits.newCredit.creditPrice,
					usState: location === false ? null : location,
					paymentRequest: {
						...credits.newCredit.paymentRequest,
						nonce: nonce,
						cardId: null,
					},
				};
				if (cardIdInfo && user.email===paymentUser) {
					requestBodyBundle.paymentRequest.cardId = cardIdInfo;
				} else requestBodyBundle.paymentRequest.nonce = nonce;
				if (referralInvite) {
					requestBodyBundle["referralCodeRequestId"] = invitation.id;
				}
				if (amount !== Number(requestBodyBundle.paymentRequest.amount.split(" ")[1]) && referralInvite) {
					requestBodyBundle.paymentRequest.amount = `USD ${amount.toFixed(2)}`;
				}
				dispatch(purchaseCredits(requestBodyBundle))
					.then((res) => {
						let requestBodyAppt = {
							animalId: scheduling.selectedPetId,
							vetSpecialty: specialty,
							vetUserId: scheduling.vetId,
							description: scheduling.additionalInfo,
							chatId: Math.floor(Math.random() * 10001),
							timesRequested: formattedPickedTimeSlot,
							appointmentType: scheduling.serviceType,
							creditRequestId: res.creditRequestEntities[0].id,
							funnelEmailGiftId: !!scheduling.funnelEmailGiftId ? scheduling.funnelEmailGiftId : null
						};
						if (referralInvite) requestBodyAppt["useReferralCodeRequests"] = true;
						// const consentForm = JSON.parse(window.localStorage.getItem("pdf"));
						let imgData = JSON.parse(scheduling.pdf);
						const pdf = new jsPDF();
						pdf.addImage(imgData, "jpeg", 20 , 5, iOS() ? 130 : 170, iOS() ? 280 : 260, "consentForm", "NONE", 0);
						// pdf.save("download.pdf");
						const pdfParams = {
							clientId: user["userId"],
							imageUrl: "",
							created: moment.utc().format(),
							vetId: scheduling.vetId,
						};
						dispatch(postAppointmentRequest(requestBodyAppt))
							.then(async (res) => {
								pdfParams["appointmentId"] = res.appointmentId;
								if (imgData !== "") {
									const firstStep = await API.addConsentForm(pdfParams).then(res => res.json());
									const url = await API.getConsentURLs(firstStep.id);
									const sendImage = await API.uploadConsentForm(url.uploadUrl, new Blob([pdf.output("blob")], {type: "application/pdf"}));
								}
								dispatch(reduceCreditsCount());
								API.postAgreement({
									type: "appointment_tos",
									userId: user["userId"],
									appointmentId: res.appointmentId
								});
								API.postAgreement({
									type: "appointment_privacy",
									userId: user["userId"],
									appointmentId: res.appointmentId
								});
								setIsRequestFinish(false);
								history.push({
									pathname: "/appointmentConfirmation",
									state: {
										appointmentId: res.appointmentId,
										total: amount,
										type: res.appointmentType,
									}
								});
							})
							.catch((err) => {
								setIsRequestFinish(false);
								setShowSpinner(false);
								if (err.nextDateStatus === "NOT_FOUND") {
									dispatch(setPaymentMethod("WITH_CREDITS"));
									history.push({pathname: "/availableVet", state: {redirect: true}});
								}
								else {
									if (err.nextAvailableTimeslot) {
										dispatch(setPaymentMethod("WITH_CREDITS"));
										dispatch(setPickedTimeSlot([err.nextAvailableTimeslot]));
										setIsInPast(true);
										myRef.current.scrollIntoView();
									} else {
										enqueueSnackbar("Unfortunately some of the used data is corrupted. Please go through schedule process again", {variant: "error"});
									}
								}
								console.log("postAppointmentRequest error: ", err);
								setShowSpinner(false);
							});
					})
					.catch((err) => {
						enqueueSnackbar(checkPaymentInfo, {
							variant: "error",
							autoHideDuration: 4000
						});
						console.log("Bundle purchase error: ", err);
						setShowSpinner(false);
					})
					.finally(() => {
						console.log("finished");
					});
			}
		}
	};


	useEffect(() => {
		if (!showSpinner) {
			(async () => {
				if (!window.Square) {
					throw new Error("Square.js failed to load properly");
				}

				const payments = window.Square.payments(process.env.REACT_APP_SQ_APPLICATION_ID);
				try {
					let newCard;
					newCard = await initializeCard(payments);
					setCard(newCard);
				} catch (e) {
					console.error("Initializing Card failed", e);
					return;
				}
				let nextDoorPixelScript = document.createElement("script");
				let content = document.createTextNode("ndp('track','CONVERSION');");
				nextDoorPixelScript.append(content);
				document.getElementsByTagName("head")[0].append(nextDoorPixelScript);
			})();
		}
	}, []);

	return (
		<>
			{showSpinner &&
            <div style={{
                position: "relative",
            	width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
            <CircularProgress/>
            </div>
			}
			{!!selectedCard && user.email===paymentUser ? <Grid md={12} className={classes.cardWrapper}>
				<Grid>
					<Typography className={classes.cardName}> {selectedCard.cardBrand} Ending
                            in {selectedCard.lastFourDigits}</Typography>
				</Grid>
				<Grid>
					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							dispatch(setIsChangeCreditCard(true));
							purchaseType !== "creditsPurchase" && setAppointmentData();
							purchaseType === "creditsPurchase" ? dispatch(setPaymentType("credits")) : dispatch(setPaymentType("appointment"));
							history.push("/paymentInformation");
						}}
					>
                            Change
					</Button>
				</Grid>
			</Grid>
				: <form id="payment-form">
					<div id="card-container"></div>
				</form>}

			{(!!withSaveForNext && user.email===paymentUser) && <Box display="flex" marginBottom="10px" marginTop="-15px" alignItems="center">
				<Checkbox
					color="secondary"
					icon={<CheckboxBorder/>}
					value={saveForLater}
					onChange={() => {
						setSaveForLater(!saveForLater);
					}}
				/>
				<Box>
					<Typography>
                        Save card for later
					</Typography>
				</Box>
			</Box>}
			<Button variant="contained" fullWidth color="secondary" disabled={disabled}
				onClick={(event) => handleClick(event, card)}>
				{hasSubscription ? "Enroll and Pay" : "Complete Payment"}
			</Button>
			<div id="payment-status-container"></div>
			<noscript>
				<img height="1" width="1" style={{display: "none"}}
					src="https://flask.nextdoor.com/pixel?pid=cd8abc59-39d9-44dd-9e64-c07769ccf70a&ev=CONVERSION&noscript=1"/>
			</noscript>
		</>
	);
};

export default PaymentForm;

